import { List, ListItem, ListItemText } from "@mui/material"

export function FeatureFlagDescription() {
    return (
        <List disablePadding>
            <ListItem
                sx={{
                    p: 0,
                    pb: 1,
                }}
            >
                <ListItemText
                    primary={`\u2022 Enables clients to request the download of maintenance regime schedules as a PDF booklet via a sharing link.`}
                />
            </ListItem>
            <ListItem
                sx={{
                    p: 0,
                    pb: 1,
                }}
            >
                <ListItemText
                    primary={`\u2022 Enables professional services to download maintenance regime schedules as a PDF booklet via a sharing link.`}
                />
            </ListItem>
            <ListItem
                sx={{
                    p: 0,
                    pb: 1,
                }}
            >
                <ListItemText primary={`\u2022 This feature is available via the add on product FIQBOOKLET.`} />
            </ListItem>
        </List>
    )
}
